const folder = {
  state: {
    folderId: 0,
    firstFoldId: '',
    folderName: '',
    folderList: []
  },
  getters: {
    folderList: state => state.folderList
  },
  mutations: {
    setFolderId: (state, folderId) => {
      state.folderId = folderId
    },
    firstFoldId: (state, firstFoldId) => {
      state.firstFoldId = firstFoldId
    },
    setFolderName: (state, folderName) => {
      state.folderName = folderName
    },
    setFolderList: (state, folderList) => {
      state.folderList = folderList
    }
  },
  actions: {
    handleFolderList (folderList, data) {
      folderList.commit('setFolderList', data)
    }
  }
}
export default folder
